module.exports = __webpack_public_path__ + "static/media/idfor.47b2a2c4.png";